import React, {useState, useEffect, useRef, Fragment} from 'react'

import {TextField,   Button,Divider, Container, Grid, Typography, InputAdornment, Table, TableHead, TableBody, TableCell
, TableRow, Badge} from '@material-ui/core'
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
import Conexao from '../../providers/Conexao'
import ConexaoB from '../../providers/ConexaoB'
import Swal from 'sweetalert2'
import {withRouter} from 'react-router-dom'
import Principal from '../Template/TemplateRevenda';
import {Breadcrumbs} from '@material-ui/core'
import {Link , useHistory } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress';
import AddIcon from '@material-ui/icons/Add'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ExtensionTwoToneIcon from '@material-ui/icons/ExtensionTwoTone';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import Axios from 'axios'
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew'; //case 2 
import SettingsPowerTwoToneIcon from '@material-ui/icons/SettingsPowerTwoTone';//energsaving
import ReportProblemIcon from '@material-ui/icons/ReportProblem';//case 5
import PrintIcon from '@material-ui/icons/Print';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import HelpIcon from '@material-ui/icons/Help';
import SettingsPowerIcon from '@material-ui/icons/SettingsPower';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import TablePagination from '@material-ui/core/TablePagination';
import ModalAlterarSenha from './ModalAlterarSenha';
import BlockIcon from '@material-ui/icons/Block';
import Alert from '@material-ui/lab/Alert'
import LinkIcon from '@material-ui/icons/Link';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import NetworkCheckIcon from '@material-ui/icons/NetworkCheck';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';

import GestureIcon from '@material-ui/icons/Gesture'
import DoorOpen from '@material-ui/icons/MeetingRoom'
import LinkOn from '@material-ui/icons/Link'
import LinkOff from '@material-ui/icons/LinkOff'
import Slider from '@material-ui/core/Slider'
import { Add } from 'react-ionicons';
import ModalNovaRevenda from './ModalNovaRevenda';
import ModalAlteraRevenda from './ModalAlteraRevenda';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Impressao } from './Impressao';
import LogoDatabit from '../../components/imagens/logo-databit.png'


pdfMake.vfs = pdfFonts.pdfMake.vfs;



let temporizador = null;
let totalDesabiltiados = parseInt(0);
let totalHabilitados = parseInt(0);
let totalGeral = parseInt(0);
let totalCobrar = parseInt(0)
let totalDescobertos = parseInt(0)
const Revendas = (props)=>{
    let history = useHistory();
    const classes = useStyles();
    const {codigoEmpresa, codigoUsuario} = props.location.state;
    const [loading, setLoading] = useState(false)
  
    const [parametroFiltro, setParametroFiltro] = useState([])
    const [filtro, setFiltro] = useState([])
 
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [ empresas, setEmpresas] = useState([])
    const [ coleta, setColeta] = useState([])
    const [ registros, setRegistros] = useState(0)
   
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(100);
    const [parametroToner, setParametroToner] = React.useState(100);
    const [equipamentos, setEquipamentos] =useState([])
    const refTipoDataPesquisa = React.useRef();
    const refDataInicial = React.useRef();
    const refDataFinal = React.useRef();
    const refPlaca = React.useRef();
    const refNumeroSerie = React.useRef();
    const refModelo = React.useRef();
    const refMarca = React.useRef();
    const refInativos = React.useRef();    
    const refRazaoSocial = React.useRef();
    const refStatus = React.useRef();
    const refNivelToner = React.useRef();
    const refCorToner = React.useRef();


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };



    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(()=>{
        getData();
        setPage(0)
        
    }, [])


    useEffect(()=>{
        getData();
    }, [page, rowsPerPage])


    
    
    

    const clearForm = () =>{
        if(refTipoDataPesquisa.current){
            refTipoDataPesquisa.current.value  ='COLETA';
        }
        if(refDataInicial.current){
            refDataInicial.current.value  = '';
        }
        if(refDataFinal.current){
            refDataFinal.current.value  = '';
        }
        if(refPlaca.current){
            refPlaca.current.value  ='';
        }
        if(refNumeroSerie.current){
            refNumeroSerie.current.value  ='';
        }
        if(refModelo.current){
            refModelo.current.value  ='';
        }
        if(refMarca.current){
            refMarca.current.value  ='';
        }
        if(refRazaoSocial.current){
            refRazaoSocial.current.value  ='';
        }
        if(refInativos.current){
            refInativos.current.value  ='t';
        }

        if(refNivelToner.current){
            refNivelToner.current.value  ='100';
        }
        if(refCorToner.current){
            refCorToner.current.value  ='';
        }
       

    
        setPage(0)
          
    }
   

    const getData = () =>{
        setLoading(true)
        Conexao.post('empresasController/getRevendas', {
           
           
        }).then(response=>{
            if(response.data.status == 'OK'){
                setEmpresas(response.data.payload)
              
            }else{
                setEmpresas([])  
            }
            setLoading(false)
        }).catch(error =>{
            setEmpresas([])  
            setLoading(false)
            
        });
    }


    const renderStatus = (status)=>{
        if(status =='f'){
            return <div className='bnt-inativa'>INATIVA</div>
        }else{
            return <div className='bnt-ativa'>ATIVA</div>
        }
    }

    const calcularValor = (quantidade) =>{
        if(quantidade > 10000){
            return Math.floor( 0.80 * quantidade)
        }
        if(quantidade > 5000 ){
            return Math.floor( 1 * quantidade)
        }
        if(quantidade > 1000){
            return Math.floor( 1,50 * quantidade)
        }
        if(quantidade > 500){
            return Math.floor( 1.80 * quantidade)
        }
        if(quantidade > 250){
            return Math.floor( 2.20 * quantidade)
        }
        if(quantidade < 250){
            return Math.floor( 2.50 * quantidade)
        }

    }
    

    const tableData = [
        ['Nome Faixa', 'início', 'até', 'Valor'],
        ['Faixa 1', '1', '250', 'R$ 1,80'],
        ['Faixa 2', '251', '500', 'R$ 1,60'],
        ['Faixa 3', '501', '1000', 'R$ 1,40'],
        ['Faixa 4', '1001', '5000', 'R$ 1,20'],
        ['Faixa 5', '5001', '10000', 'R$ 0,90'],
        ['Faixa 6', '10001', '','R$ 0,80']
    ];

    let dataEquipamentos = [];
    const getEquipamentoPorRevenda = (empresa) =>{
        dataEquipamentos = [];
        setLoading(true)
        Conexao.get('empresasController/getEquipamentoFaturamentoRevenda?idempresa='+empresa.idusuario).then(response=>{
            if(response.status == 200 && response.data.status =='OK'){
                const temp = response.data.payload;
                let totalEquipamentos = response.data.payload.length
                let totalDescobertos = 0;
                let totalDesabilitados = 0;
                let totalHabilitados = 0;
                let totalCobrar = 0;
               
                for(let i = 0; i < response.data.payload.length; i++ ){
                    

                    
                    if(response.data.payload[i].ativo =='f'){
                        totalDesabilitados++;
                    }

                   

                    if(response.data.payload[i].ativo =='t' && response.data.payload[i].equipamentonovo =='f'){
                        totalHabilitados++;
                    }

                    if(response.data.payload[i].ativo =='t' && response.data.payload[i].equipamentonovo =='t'){
                        totalDescobertos++;
                    }

                   
                    if(response.data.payload[i].dias <= 30 && response.data.payload[i].ativo =='t'){
                        totalCobrar++;
                    }
                }
                empresa.totalCobrar = totalCobrar;
                empresa.totalHabilitados = totalHabilitados
                empresa.totalDesabilitados = totalDesabilitados
                empresa.totalDescobertos = totalDescobertos
                empresa.totalEquipamentos = totalEquipamentos
                
                if(empresa.valorfixo =='t'){
                    empresa.valorcobrar = empresa.totalCobrar * empresa.valorcontratado
                    if(empresa.valorcontratado < 1.00 && totalCobrar < 2000){
                        empresa.valorA3M = empresa.valorcobrar * 0.20;
                    }else{
                        empresa.valorA3M = empresa.valorcobrar * 0.20;  
                    }
                }else{
                    if(totalCobrar >=1 && totalCobrar <= 250){
                        empresa.valorcobrar = empresa.totalCobrar * 1.8
                        empresa.valorAplicado = 1
                    }
                    if(totalCobrar >=251 && totalCobrar <= 500){
                        empresa.valorcobrar = empresa.totalCobrar * 1.6
                        empresa.valorAplicado = 2
                    }
                    if(totalCobrar >=501 && totalCobrar <= 1000){
                        empresa.valorcobrar = empresa.totalCobrar * 1.4
                        empresa.valorAplicado = 3
                    }
                    if(totalCobrar >=1001 && totalCobrar <= 5000){
                        empresa.valorcobrar = empresa.totalCobrar * 1.2
                        empresa.valorAplicado =4
                    }
                    if(totalCobrar >=5001 && totalCobrar <= 10000){
                        empresa.valorcobrar = empresa.totalCobrar * 0.9
                        empresa.valorAplicado = 5
                    }
                    if(totalCobrar >10000){
                        empresa.valorcobrar = empresa.totalCobrar * 0.8
                        empresa.valorAplicado = 6
                    }
                    empresa.valorA3M = empresa.valorcobrar * 0.2
                }
                setLoading(false)
                Swal.fire({
                    title :'Printerconnect', 
                    text :'Incluir no relatório a listagem de equipamentos?', 
                    icon : 'question', 
                    showConfirmButton : true, 
                    confirmButtonText : 'Sim', 
                    showCancelButton : true, 
                    cancelButtonText : 'NÃO'
                }).then(resposta=>{
                    if(resposta.isConfirmed){
                        dataEquipamentos = [
                            ['Número de Série', 'Marca', 'Modelo',  'Cadastro', 'Atualização'],
                            ...response.data.payload.filter(item => item.ativo =='t' && item.equipamentonovo =='f').map((item, index) => [
                              item.numeroserie,
                              item.marca,
                              item.modelo,
                              item.datacadastro,
                              item.datacoleta, 
                              
                            ]),
                          ];
                        visualizarImpressao(empresa, true);
                    }else{
                        visualizarImpressao(empresa, false);
                    }
                })
                
            }else{
                setEquipamentos([])
            }
        }).catch(error=>{
            setEquipamentos([])
        })
    }


    const calcularDiferencaDias = (data, tipo = "dias") =>{
      
        var dataAtual = new Date();

// Obtenha os componentes da data
        var dia = dataAtual.getDate();
        var mes = dataAtual.getMonth() + 1; // Lembre-se de que os meses são indexados de 0 a 11
        var ano = dataAtual.getFullYear();

        // Obtenha os componentes da hora
        var horas = dataAtual.getHours();
        var minutos = dataAtual.getMinutes();
        var segundos = dataAtual.getSeconds();

        // Formate a data e hora conforme necessário
        var dataFormatada = dia+ '/' + mes + '/' + ano;
        var horaFormatada = horas + ':' + minutos + ':' + segundos;

        return dataFormatada+ ' '+horaFormatada
    }


    
    const visualizarImpressao = (empresa, opcao) => {
        try{
        let imprimirEquipamentos = false
        
        const logoUrl = "data:image/png;base64,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";
        const docDefinition = {
            pageOrientation: 'portraid',
            content: [
                {
                    image: logoUrl,
                    width: 100, // Ajuste conforme necessário
                },
                { text: '', margin: [0, 10], style:'header' }, // Adiciona um espaço (margem) entre o logotipo e a linha
                { text: 'Printerconnect - Relatório de Fechamento', margin: [0, 10], style:'header' }, // Adiciona um espaço (margem) entre o logotipo e a linha
                { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 520, y2: 0, lineWidth: 0.5 }] , margin: [0, 10]}, // Adiciona uma linha
                
                
                {
                    text: "Revenda: " + empresa.nome,
                    style: 'nomeEmpresa',
                     margin: [0, 1]
                },
   
                {
                    text: "Cidade: " +  empresa.cidade+' - '+empresa.estado,
                    style: 'endereco',
                     margin: [0, 1]
                },
 
                 
        {
            columns: [
              // Primeira coluna
              {
                width: '50%',
                stack: [
                    { text: 'Data e hora relatório', margin: [0, 1] },
                  { text: 'Tipo de Contrato/Licença', margin: [0, 1] },
                  { text: 'Cobrar por valor fixo', margin: [0, 1] },
                  { text: 'Valor inicial', margin: [0, 1] },
                  { text: 'Equipamentos cadastrados', margin: [0, 1] },
                  { text: 'Equipamentos desabilitados', margin: [0, 1] },
                  { text: 'Equipamentos descobertos (aguardando)', margin: [0,1] },
                  { text: 'Equipamentos Ativos', margin: [0,1] },
                  { text: 'Total Gerenciado no período', margin: [0,1] },
                  { text: 'Total a cobrar', margin: [0,1] },
                  { text: codigoEmpresa == 31 ? 'Valor PRINTERCONNECT' : '', margin: [0,1] },
                  
                ],
              },
              // Segunda coluna
              {
                width: '50%',
                stack: [
                { text: calcularDiferencaDias(), margin: [0, 1] },
                  { text: (empresa.habilitarcobranca  == 't' ? 'Licença/Contrato' : "Demonstração/Teste"), margin: [0, 1] },
                  { text:  empresa.habilitarcobranca =='t' ? (empresa.valorfixo  == 't' ? 'Sim' : "Cobrança por faixa de valor") : "* Licença de demonstração", margin: [0,1] },
                  { text: empresa.valorfixo == 't' ? (empresa.valorcontratado ? empresa.valorcontratado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : "* Não informado" ) : "Contrato operando na faixa " + empresa.valorAplicado + 'º de valor.', margin: [0,1] },
                  { text: empresa.totalEquipamentos, margin: [0,1] },
                  { text: empresa.totalDesabilitados, margin: [0,1] },
                  { text: empresa.totalDescobertos, margin: [0,1] },
                  { text: empresa.totalHabilitados, margin: [0,1] },
                  { text: empresa.totalCobrar, margin: [0,1] },
                  { text: empresa.valorcobrar.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), margin: [0,1] },
                  { text: codigoEmpresa == 31 ?  empresa.valorA3M.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '', margin: [0,1] },
                ],
              },
            ],
          },

          
          { text: '', margin: [0, 10] },
                {
                    table: {
                        headerRows: 1,
                        widths: ['*', '*', '*', '*'],
                        body: tableData,
                        margin : [0,10]
                    },
                    layout: 'lightHorizontalLines',
                    style: 'tableStyle', // Estilo da tabela
                },
                { text: codigoEmpresa == 3199 ? '* Quando o contrato tiver valor fixo por equipamento e o mesmo (valor fixo) for abaixo de R$ 1,00 (um real) e a quantidade de equipamentos monitorados no período for menor que 2 mil equipamentos, será cobrado o valor de R$ 0,25 (vinte e cinco centavos) por equipamento e não 20% sobre o valor faturado.':'', margin: [0, 10] , style:'lembrete'},
                opcao ? {
                    table: {
                      headerRows: 1,
                      widths: ['25%', '15%', '40%', '10%', '10%'],
                      body: dataEquipamentos,
                      margin : [0,10],
                    },
                    layout: 'lightHorizontalLines',
                    style: 'tableStyle2', // Estilo da tabela
                  }: { text: '', margin: [0, 10] , style:'lembrete'},
            ],
            styles: {
                header :{
                    fontSize: 16,
                    alignment: 'center', 
                },
                reportTitle :{
                    fontSize: 14,
                    alignment: 'left', 
                },
                subheader: {
                    fontSize: 12,
                    bold: false,
                },
                nomeEmpresa: {
                    fontSize: 12,
                    bold: false,
                },
                endereco: {
                    fontSize: 12,
                    bold: false,
                },
                bold: {
                    fontSize: 12,
                    bold: true,
                },
                tableStyle: {
                    fontSize: 9, // Ajuste o tamanho da fonte da tabela aqui
                },
                tableStyle2: {
                    fontSize: 6, // Ajuste o tamanho da fonte da tabela aqui
                },
                lembrete :{
                    fontSize :7, 
                    color:'red'
                }
            },
        };
        const pdfDoc = pdfMake.createPdf(docDefinition).download('relatoriofechamento_empresa_'+empresa.idusuario+'.pdf');;

        // Abre o PDF em uma nova janela do navegador
        pdfDoc.open();
    }catch(e){
            
    }
   
    }

    
      
      
    return <Principal atualizar = {loading} full={true} breadcrumbs={
        <Breadcrumbs aria-label="breadcrumb">  
        <Typography>Você esta em:</Typography>          
            <Link color="inherit" to={'#'} >
                Lista de Revendas
            </Link>                
        </Breadcrumbs>
    }>
       <Grid container spacing = {1}>
           
            <Grid item xs={7}>
               
            </Grid>
            <Grid item xs = {5}>
            <TablePagination
                component="div"
                count={registros}
                page={page}
                onChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage='Linhas por página'
                />
            </Grid>
        </Grid>
        
        <Grid container spacing = {1}>
            <Grid item xs = {2}>
                <TextField
                    label ='Tipo Data'
                    variant ='outlined'
                    fullWidth
                    InputLabelProps={{shrink : true}}
                    select
                    SelectProps={{native : true}}
                    inputRef={refTipoDataPesquisa}
                    
                    size ='small'
                    >
                    <option>COLETA</option>
                    <option>CADASTRO</option>
                    
                    </TextField>
            </Grid>
            <Grid item xs = {2}>
                <TextField
                    label ='Data'
                    variant ='outlined'
                    fullWidth
                    size ='small'
                    InputLabelProps={{shrink : true}} 
                    type= 'date'    
                   
                    inputRef={refDataInicial}             
                   />
            </Grid>
            <Grid item xs = {2}>
                <TextField
                    label ='Data'
                    variant ='outlined'
                    fullWidth
                    size ='small'
                    InputLabelProps={{shrink : true}} 
                    type= 'date'
                   
                    inputRef={refDataFinal}             
                   />
            </Grid>
            <Grid item xs = {3}>
                <TextField
                    label ='Status'
                    variant ='outlined'
                    fullWidth
                    inputRef={refStatus}
                    InputLabelProps={{shrink : true}}
                    select
                    SelectProps={{native:true}}
                    size ='small'
                    >
                        <option value ={-1}>TODOS</option>
                        <option value ={1}>DESCONHECIDO</option>
                        <option value ={3}>ENERGY SAVING</option>
                        <option value ={2}>ON LINE</option>                        
                        <option value ={4}>IMPRIMINDO</option>
                        <option value ={6}>ATENÇÃO</option>
                        <option value ={8}>PORTA ABERTA</option>
                        <option value ={7}>ATOLAMENTO</option>
                        <option value ={5}>OCORRENCIA</option>
                        
                        
                        
                </TextField>                   
                </Grid>


            <Grid item xs = {1}>
                <TextField
                    label ='Placa'
                    variant ='outlined'
                    fullWidth
                    size ='small'
                    InputLabelProps={{shrink : true}}  
                    inputRef={refPlaca}                  
                   />
            </Grid>
            <Grid item xs = {2}>
                <TextField
                    label ='Número Série'
                    variant ='outlined'
                    fullWidth
                    size ='small'
                    InputLabelProps={{shrink : true}} 
                    inputRef={refNumeroSerie}                   
                   />
            </Grid>
            
            
        </Grid>
        <Grid container spacing = {1} style ={{marginTop:"10px"}}>
            
            <Grid item xs = {2}>
                <TextField
                    label ='Marca'
                    variant ='outlined'
                    fullWidth
                    InputLabelProps={{shrink : true}}
                    inputRef={refMarca}
                    size ='small'
                    />                   
            </Grid>
            <Grid item xs = {3}>
                <TextField
                    label ='Modelo'
                    variant ='outlined'
                    fullWidth
                    size ='small'
                    InputLabelProps={{shrink : true}} 
                    inputRef={refModelo}                   
                   />
            </Grid>
            <Grid item xs = {4}>
                <TextField
                    label ='Razão Social'
                    variant ='outlined'
                    fullWidth
                    InputLabelProps={{shrink : true}}
                    inputRef={refRazaoSocial}
                    size ='small'
                    />                   
            </Grid>
            <Grid item xs = {2}>
                <TextField
                    label ='Pesquisar Cor'
                    variant ='outlined'
                    fullWidth
                    defaultValue='100'
                    InputLabelProps={{shrink : true}}
                    inputRef={refCorToner}
                    type='number'
                    size ='small'
                    select
                    SelectProps={{native : true}}
                    >
                        <option value='f'></option>
                         <option value='all'>TODOS</option>
                        <option value='nivelCiano'>CIANO</option>
                        <option value='nivelMagenta'>MAGENTA</option>
                        <option value='nivelAmarelo'>AMARELO</option>
                        <option value='nivelPreto'>PRETO</option>
                </TextField>                   
            </Grid>
            <Grid item xs = {1}>
                <TextField
                    label ='Nivel %'
                    variant ='outlined'
                    fullWidth
                    defaultValue='100'
                    InputLabelProps={{shrink : true}}
                    inputRef={refNivelToner}
                    type='number'
                    size ='small'
                    />                   
            </Grid>

        </Grid>
        <Grid container spacing={1} style ={{marginTop:"10px"}}>
            <Grid item xs = {9} spacing={2}>
                
            </Grid>
            <Grid item xs = {3} spacing={2} className='container-buttons'>
                <Button color = 'primary' variant='contained' onClick={()=>getData()}><SearchIcon/> Pesquisar</Button>
                <Button color='secondary' variant='contained' onClick={()=>clearForm()}><ClearIcon/> Limpar</Button>
            </Grid>

        </Grid>
       
        <div className='div-form-container'>
        <Grid spacing={1}>
            <Table className='table table-bordered table-striped table-hover table-small table-sm' >
                <TableHead>
                    <TableCell align='center' style = {{width:"5%"}}>ID</TableCell>
                    <TableCell align='center' style = {{width:"10%"}}>CNPJ</TableCell>  
                    <TableCell align='left' style = {{width:"35%"}}>Razão Social</TableCell>                    
                    <TableCell align='left' style = {{width:"20%"}}>Cidade</TableCell>
                    <TableCell align='center' style = {{width:"5%"}}>Estado</TableCell>
                    <TableCell align='center' style = {{width:"5%"}}>Empresas</TableCell> 
                    <TableCell align='center' style = {{width:"5%"}}>Senha</TableCell> 
                    <TableCell align='center' style = {{width:"5%"}}>Relatório</TableCell> 
                   
                    
                </TableHead>
                
                
                <TableBody>
                    {
                        empresas && empresas.map(function(empresa, i){
                           
                            return <TableRow id={i} key ={i}>
                            <TableCell align='center' >
                                {empresa.idusuario != 20 ? <ModalAlteraRevenda revenda = {empresa} getData ={()=>getData()}/> : ''}
                            </TableCell>
                            <TableCell align='center' >{empresa.cpf_cnpj}</TableCell>  
                            <TableCell align='left'>{empresa.nome}</TableCell>                    
                            <TableCell align='left' >{empresa.cidade}</TableCell>
                            <TableCell align='center' >{empresa.estado}</TableCell>
                            <TableCell align='center' >{empresa.empresas}</TableCell>

                            <TableCell align='center'>{empresa.idusuario != 20 ? <ModalAlterarSenha nome={empresa.nome} Conexao={Conexao} idusuario={empresa.idusuario}/>: ''}</TableCell>
                            <TableCell align='center' >
                                {empresa.idusuario != 20 ?  <Button variant='contained' onClick = {()=>{
                                    getEquipamentoPorRevenda(empresa)
                                }}>
                                    <PrintIcon />
                                </Button> : ''}
                            </TableCell>
                            
                        </TableRow>
                        })
                    }

                       
                </TableBody>
            </Table>
        </Grid>                     
        </div>
        <div className='fabIncluir'>
           <ModalNovaRevenda />
        </div>
     


    </Principal>
}

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
  }));

export default withRouter(Revendas)